import _ from 'lodash'
// note: Google Identity JavaScript library
//       (https://accounts.google.com/gsi/client - required for Google Authorization)
//       is loaded in <GoogleOAuthProvider> on AppContainer.js
//       which is used by Sign in with Google

const gCBaseScopes = 'email profile openid https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.courses.readonly'
const gCWithRosterEmailScopes = `${gCBaseScopes} https://www.googleapis.com/auth/classroom.profile.emails`
const scopesByGroup = {
  googleClassroomBase: gCBaseScopes,
  googleClassroomWithRosterEmail: gCWithRosterEmailScopes,
}

export default function requestGoogleAuthCode({
  onSuccess,
  onFailure = () => {},
  hint,
  scopeGroup,
}) {
  const scopes = scopesByGroup[scopeGroup]
  const client = window.google.accounts.oauth2.initCodeClient({
    /* eslint-disable camelcase */
    client_id: process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID,
    scope: scopes,
    ux_mode: 'popup',
    callback: (codeResponse) => {
      if (!codeResponse.code) { // user clicks cancel button
        onFailure('noCode')
        return
      }
      if (!checkIfAuthorizedAllScopes(codeResponse, scopes)) {
        onFailure('insufficientScopes')
        return
      }
      onSuccess(codeResponse)
    },
    error_callback: (error) => {
      const type = error.type === 'popup_closed' ?
        'noCode' :
        error.type
      onFailure(type)
    },
    hint,
    /* eslint-enable camelcase */
  })

  return client.requestCode()
}

function checkIfAuthorizedAllScopes(codeResponse, scopes) {
  if (!codeResponse.scope) return false
  const authorizedScopes = codeResponse.scope.split(' ')
  const requiredScopes = scopes.split(' ')
  return _.difference(requiredScopes, authorizedScopes).length === 0
}
